import { useMutation, UseMutationResult } from "@tanstack/react-query";
import { WiseOwlApi } from "@twiliointernal/org/twilio/e2-commons/shared/api";

import {
  WiseOwlApiResponse,
  WiseOwlGetChatSummaryByIdResponseData,
  WiseOwlIngress,
  WiseOwlProps,
} from "@twiliointernal/org/twilio/e2-commons/shared/definitions";

const useGetChatSummary = ({
  applicationId,
  ingress,
  stargateUngatedUserId,
  ticket,
  token,
}: WiseOwlProps): UseMutationResult<
  WiseOwlApiResponse<WiseOwlGetChatSummaryByIdResponseData>,
  any,
  string
> => {
  return useMutation({
    mutationFn: async (chatId: string) => {
      const wiseOwlApi = new WiseOwlApi(ingress);
      const csrf = await wiseOwlApi.getCsrf();

      switch (ingress) {
        case WiseOwlIngress.oscUngated: {
          return wiseOwlApi.ungatedGetChatSummaryById({
            chatId,
            body: {
              stargateUngatedUserId,
            },
            headers: {
              "x-twilio-csrf": csrf,
            },
            requestOptions: {
              credentials: "include",
            },
          }) as Promise<
            WiseOwlApiResponse<WiseOwlGetChatSummaryByIdResponseData>
          >;
        }
        case WiseOwlIngress.osc: {
          return wiseOwlApi.getChatSummaryById({
            ingress,
            chatId,
            headers: {
              "x-twilio-csrf": csrf,
            },
            requestOptions: {
              credentials: "include",
            },
          }) as Promise<
            WiseOwlApiResponse<WiseOwlGetChatSummaryByIdResponseData>
          >;
        }
        case WiseOwlIngress.console: {
          return wiseOwlApi.getChatSummaryById({
            ingress,
            chatId,
            applicationId,
            headers: {
              "x-twilio-csrf": csrf,
            },
            requestOptions: {
              credentials: "include",
            },
          }) as Promise<
            WiseOwlApiResponse<WiseOwlGetChatSummaryByIdResponseData>
          >;
        }
        case WiseOwlIngress.zendesk: {
          return wiseOwlApi.getChatSummaryById({
            ingress,
            chatId,
            ticketId: ticket.id.toString(),
            headers: {
              "zendesk-user-id": "12345",
              "wozd-auth": token,
            },
            requestOptions: {
              credentials: "include",
            },
          }) as Promise<
            WiseOwlApiResponse<WiseOwlGetChatSummaryByIdResponseData>
          >;
        }
        case WiseOwlIngress.salesforce: {
          return wiseOwlApi.getChatSummaryById({
            ingress,
            chatId,
            headers: {
              "TODO-SF-HEADER": "TODO-SF-HEADER",
              "TODO-SF-SECOND-HEADER": "TODO-SF-SECOND-HEADER",
            },
            requestOptions: {
              credentials: "include",
            },
          }) as Promise<
            WiseOwlApiResponse<WiseOwlGetChatSummaryByIdResponseData>
          >;
        }
      }
    },
  });
};

export default useGetChatSummary;
